export const nutrients = [
 ['energyKcal100g','Energia','kcal'],['protein100g','Proteine','g'],
 ['carbohydrate100g','Carboidrati','g'],['fat100g','Grassi','g'],
 ['fiber100g','Fibre','g'],['salt100g','Sale','g']
];
const number = value => value!==null && value!==undefined && String(value).trim()!=='' && Number.isFinite(Number(value)) && Number(value)>=0 ? Number(value) : null;
const blank = () => Object.fromEntries(nutrients.map(([key])=>[key,null]));
function grams(row) {
 const quantity=number(row.quantity);if(quantity===null||quantity<=0)return null;
 const unit=(row.unit||'').trim().toLowerCase();
 return unit==='g'?quantity:unit==='kg'?quantity*1000:null;
}
export function rowNutrition(row,foods={},recipes={}) {
 if(row.foodRecipeId){
  const recipe=recipes[row.foodRecipeId],quantity=number(row.quantity);
  if(!recipe?.ingredients?.length)return {values:blank(),reason:'Ricetta senza ingredienti disponibili'};
  if(!['porzione','porzioni'].includes((row.unit||'').toLowerCase())||!quantity||!(recipe.servings>0))return {values:blank(),reason:'La ricetta richiede una quantità in porzioni e il numero di porzioni della preparazione'};
  const parts=recipe.ingredients.map(ingredient=>rowNutrition(ingredient,{...foods,[ingredient.foodCatalogItemId]:ingredient.foodCatalogItem||foods[ingredient.foodCatalogItemId]},{}));
  const values=Object.fromEntries(nutrients.map(([key])=>[key,parts.some(part=>part.values[key]===null)?null:parts.reduce((sum,part)=>sum+part.values[key],0)*quantity/recipe.servings]));
  return {values,reason:parts.some(part=>part.reason)?'Ingredienti della ricetta incompleti o con unità non convertibile':null};
 }
 const food=foods[row.foodCatalogItemId];
 if(!food)return {values:blank(),reason:'Alimento non collegato o non disponibile nel catalogo'};
 const weight=grams(row);
 if(weight===null)return {values:blank(),reason:'Indicare grammi: manca una conversione attendibile per questa quantità/unità'};
 const values=Object.fromEntries(nutrients.map(([key])=>[key,number(food[key])===null?null:Number(food[key])*weight/100]));
 return {values,reason:nutrients.some(([key])=>values[key]===null)?'Uno o più nutrienti non disponibili nel catalogo':null};
}
export function summarizeNutrition(rows,foods={},recipes={}) {
 const parts=rows.filter(row=>(row.food||row.name||'').trim()).map(row=>({row,...rowNutrition(row,foods,recipes)}));
 return {parts,count:parts.length,values:Object.fromEntries(nutrients.map(([key])=>{
  const known=parts.filter(part=>part.values[key]!==null);
  return [key,{value:known.length?known.reduce((sum,part)=>sum+part.values[key],0):null,missing:parts.length-known.length,complete:parts.length>0&&known.length===parts.length}];
 }))};
}
